const initialState = {
  today: null,
  tomorrow: null,
  loading: false,
  error: null,
  lastUpdated: null,
  // Range (lookahead)
  range: null,
  rangeLoading: false,
  rangeError: null,
  rangeLastUpdated: null,
};

export default function halachicEngineReducer(state = initialState, action) {
  switch (action.type) {
    case 'HALACHIC_ENGINE_START':
      return { ...state, loading: true, error: null };

    case 'HALACHIC_ENGINE_SUCCESS':
      return {
        ...state,
        today: action.payload.today,
        tomorrow: action.payload.tomorrow,
        loading: false,
        error: null,
        lastUpdated: Date.now(),
      };

    case 'HALACHIC_ENGINE_ERROR':
      return { ...state, loading: false, error: action.payload };

    case 'HALACHIC_ENGINE_CLEAR':
      return initialState;

    // Range (lookahead) actions
    case 'HALACHIC_ENGINE_RANGE_START':
      return { ...state, rangeLoading: true, rangeError: null };

    case 'HALACHIC_ENGINE_RANGE_SUCCESS':
      return {
        ...state,
        range: action.payload.range,
        rangeLoading: false,
        rangeError: null,
        rangeLastUpdated: Date.now(),
      };

    case 'HALACHIC_ENGINE_RANGE_ERROR':
      return { ...state, rangeLoading: false, rangeError: action.payload };

    default:
      return state;
  }
}
